import { ReportDetails } from "@idwal/idwal-react-components";
import { useMemo } from "react";
import { LoadingParticulars } from "../loading/LoadingParticulars";
import { ScreeningItem } from "../../types/Screening";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/numberHelpers";
import { ScreeningFlagBody } from "./ScreeningFlagBody";

type Props = {
    data: ScreeningItem | undefined;
    loading: boolean;
    forSale: boolean;
};

export const ScreeningHeader = (props: Props) => {
    const { data, loading, forSale } = props;

    const { t } = useTranslation("locale");

    const reportDetails = useMemo(() => {
        if (data) {
            const details = [
                {
                    key: "imoNumber",
                    value: `${data.vessel_imo}`,
                    selector: "imo"
                },
                {
                    key: "vesselType",
                    value: data.vessel_type,
                    selector: "vessel-type"
                },
                {
                    key: "flagState",
                    value: <ScreeningFlagBody data={data} />,
                    selector: "flag-state"
                },
                {
                    key: "classSociety",
                    value: `${data.class_society}${
                        data.class_code ? ` (${data.class_code})` : ""
                    }`,
                    selector: "class-society"
                },
                {
                    key: "age",
                    value: `${Number(data.age_of_vessel).toFixed(1)} y/o`,
                    selector: "age"
                },
                {
                    key: "deadweight",
                    value: `${formatNumber(data.deadweight)} MT`,
                    selector: "inspected-date"
                }
            ];

            if (Number(data.teu)) {
                details.push({
                    key: "cargoCapacity",
                    value: `${formatNumber(data.teu)} TEU`,
                    selector: "cargo-capacity"
                });
            }

            return {
                GradeImageUrl: data.image_url,
                ShipName: data.vessel_name,
                MarkedForSale: forSale,
                InspectionType: t("screening.screening"),
                Details: details
            };
        }
    }, [data, forSale]);

    if (loading || !reportDetails) {
        return <LoadingParticulars />;
    }

    return <ReportDetails reportDetails={reportDetails} />;
};
